import { createContext, useContext, useEffect, useState } from "react";
import axios, { API } from "@/lib/api";

const SiteContext = createContext(null);

const FALLBACK = {
  org_name: "KBIHU Muhammadiyah Surabaya",
  whatsapp: "6281234567890",
  phone: "+62 31 1234 5678",
  email: "info@kbihumuhammadiyahsby.id",
  address: "Jl. KH. Ahmad Dahlan No. 1, Surabaya, Jawa Timur",
  stats: { jamaah: "1.000+", program: "50+", pembimbing: "20+", tahun: "10+" },
  hero_title: "Mempersiapkan Perjalanan Ibadah dengan Ilmu, Bimbingan, dan Ketulusan.",
  hero_subtitle: "KBIHU Muhammadiyah Surabaya hadir mendampingi jamaah dalam mempersiapkan, memahami, dan menjalankan ibadah Haji dan Umrah dengan lebih baik.",
  social_links: {},
};

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(FALLBACK);

  useEffect(() => {
    axios
      .get(`${API}/public/settings`)
      .then(({ data }) => setSettings({ ...FALLBACK, ...data }))
      .catch(() => {});
  }, []);

  return <SiteContext.Provider value={{ settings, setSettings }}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);
